export default __webpack_public_path__ + "static/media/team-photo7.2e5202b7.jpg";